import React from "react";
import * as S from "./styled";
import { useHistory } from "react-router-dom";
import LogoCDS from "../../assets/images/logocds-simbolo.svg";
import CTAButton from "../CTAButton";

const StickyBar = () => {
  const history = useHistory();

  return (
    <S.Wrapper>
      <S.ContentContainer>
        <S.LogoContainer>
          <img src={LogoCDS} alt="logotipo" />
        </S.LogoContainer>
        <S.TextContainer>
          <h2>Acesso a mais de 300 cursos originais.</h2>
          <p>
            <span>A partir de R$ 39,90 mensais. </span>
            <span>7 dias de garantia para experimentar.</span>
          </p>
        </S.TextContainer>
        <S.ButtonContainer>
          <CTAButton
            rounded
            onClick={() => history.push("/signup")}
            text={"ASSINE AGORA"}
            id={"btn-sticky_bar-assine_agora"}
            name={"btn-sticky_bar-assine_agora"}
          />
        </S.ButtonContainer>
      </S.ContentContainer>
    </S.Wrapper>
  );
};

export default StickyBar;
